export type NavigationConfirmationCallback = (allowTransition: boolean) => void;

export type NavigationConfirmationHandler = (
  message: string,
  callback: NavigationConfirmationCallback
) => void;

let currentHandler: NavigationConfirmationHandler | null = null;

export function registerNavigationConfirmation(handler: NavigationConfirmationHandler): () => void {
  currentHandler = handler;

  return () => {
    if (currentHandler === handler) {
      currentHandler = null;
    }
  };
}

export const navigationConfirmation: NavigationConfirmationHandler = (message, callback) => {
  if (currentHandler) {
    currentHandler(message, callback);
    return;
  }

  callback(true);
};

export default navigationConfirmation;
